import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Modal, Status } from "@bitcine/cs-theme"
import { toggleModal } from "@api/shared_screeners/modals"
import { updateSharedScreener } from "@api/shared_screeners"

const EmailAddress = ({ sharedScreener, status, updateSharedScreener, toggleModal }) => {
  const [email, setEmail] = useState(sharedScreener.shared_email || "")
  return (
    <Modal open title={"Update Email Address for " + sharedScreener.shared_name} onClose={() => toggleModal("updateEmail")}>
      <Status pending={status === "PENDING"} error={status === "ERROR"}>
        <div>
          <input
            type='email'
            autoComplete='email'
            name='email'
            id='email'
            className='cs-input col-12 mb2'
            placeholder={"Enter new email address..."}
            value={email}
            onChange={e => setEmail(e.target.value)}/>
          <div className='flex pt2 items-start justify-end'>
            <button
              onClick={() => updateSharedScreener(sharedScreener._id, "shared_email", email)}
              className='cs-button ml1 small'
              disabled={!email.length || status === "PENDING"}>
              Save
            </button>
          </div>
        </div>
      </Status>
    </Modal>
  )
}

EmailAddress.propTypes = {
  sharedScreener: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  updateSharedScreener: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = ({ shared_screeners }) => ({
  sharedScreener: shared_screeners.modals.emailAddress.sharedScreener,
  status: shared_screeners.modals.emailAddress.status
})

const mapDispatchToProps = dispatch => ({
  updateSharedScreener: bindActionCreators(updateSharedScreener, dispatch),
  toggleModal: bindActionCreators(toggleModal, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EmailAddress)
